import classNames from 'classnames';
import './Pagination.scss';

export interface PaginationProps {
  /** css value for animation-duration. default '10s' */
  animationDuration?: string;
  /** if true there will be a loading animation when isActive. default false */
  hasAnimation?: boolean;
  /** boolean to control the background color. default false */
  isActive?: boolean;
  /** size of the pagination element. default large */
  size?: 'small' | 'large';
  /** additional class name */
  className?: string;
}

/**
 * Pagination - a loading bar that can be used in a group
 * @param animationDuration - css value for animation-duration. default '10s'
 * @param hasAnimation - if true there will be a loading animation when isActive. default false
 * @param isActive - boolean to control the background color. default false
 * @param size - size of the pagination element. default large
 * @param className - additional class name
 */
export const Pagination: React.FC<PaginationProps> = ({
  animationDuration = '10s',
  hasAnimation,
  isActive,
  size = 'large',
  className,
  ...rest
}) => (
  <div
    className={classNames(
      'vds-pagination',
      `vds-pagination--${size}`,
      hasAnimation && `vds-pagination--animate`,
      isActive && `vds-pagination--active`,
      className,
    )}
    {...rest}>
    {hasAnimation && isActive && (
      <div className="vds-pagination__inner" style={{ animationDuration }} />
    )}
  </div>
);
